module.exports = __webpack_public_path__ + "static/media/arrow-from-right.09a62bcc.svg";